"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = exports.GlobalStylesNoFont = exports.GlobalStylesNoForm = exports.GlobalStylesNoFormHeadless = exports.formStyles = void 0;

var _styledNormalize = _interopRequireDefault(require("styled-normalize"));

var _styledComponents = require("styled-components");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  @import url('https://fonts.googleapis.com/css?family=DM+Sans:400,500,700');\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  * { font-family: Helvetica, Verdana, sans-serif !important; }\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  @import url('https://fonts.googleapis.com/css?family=DM+Sans:400,500,700');\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * { font-family: Helvetica, Verdana, sans-serif !important; }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var formStyles = (0, _styledComponents.css)(["input[type='text'],input[type='email'],input[type='password'],.Select,button[class^='Select__StyledSelectDropButton']{border-radius:4px;box-shadow:none;color:", ";border:1px solid ", ";background-color:", ";input{border:0;}&:focus{background-color:", ";}}div:disabled,input:disabled,option:disabled,textarea:disabled,optgroup:disabled,select:disabled:disabled{background-color:", ";color:", ";opacity:1;div{color:", ";}input[type='text']{color:", ";}}div[class^='StyledSelect__StyledContainer'] button:disabled{background:inherit;color:", ";}[data-invalid='true']{input[type='text'],input[type='email'],input[type='password']{color:", ";background-color:", ";}}[class*='Select__StyledSelectDropButton'] [class^='StyledTextInput'] input[class*='SelectTextInput']{border-width:0 !important;border-color:transparent !important;}"], (0, _helpers.color)('black'), (0, _helpers.color)('dark-1'), (0, _helpers.color)('white'), (0, _helpers.color)('focus'), (0, _helpers.color)('statusDisabled'), (0, _helpers.color)('dark-1'), (0, _helpers.color)('dark-1'), (0, _helpers.color)('dark-1'), (0, _helpers.color)('dark-1'), (0, _helpers.color)('black'), (0, _helpers.color)('statusInvalid'));
exports.formStyles = formStyles;
var globalStyle = (0, _styledComponents.css)(["", " *{box-sizing:border-box;}body{margin:0;padding:0;font-family:", ";font-size:", ";line-height:", ";color:", ";background:", ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;overflow-x:hidden;}@media print{body{-webkit-print-color-adjust:exact;}}header a{text-decoration:none;}div[id^='orgSwitcher'][id$='__drop']{z-index:200;max-width:320px;div[id^='orgSwitcher'][id$='__select-drop'] > div > div > button > div > span{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}"], _styledNormalize.default, function (p) {
  return p.theme.global.font.family;
}, function (p) {
  return p.theme.global.font.size;
}, function (p) {
  return p.theme.global.font.height;
}, (0, _helpers.color)('black'), (0, _helpers.color)('white')); // for use in headless testing

var GlobalStylesNoFormHeadless = (0, _styledComponents.createGlobalStyle)(_templateObject(), globalStyle);
exports.GlobalStylesNoFormHeadless = GlobalStylesNoFormHeadless;
var GlobalStylesNoForm = (0, _styledComponents.createGlobalStyle)(_templateObject2(), globalStyle); // for use in headless testing

exports.GlobalStylesNoForm = GlobalStylesNoForm;
var GlobalStylesNoFont = (0, _styledComponents.createGlobalStyle)(_templateObject3(), globalStyle, formStyles);
exports.GlobalStylesNoFont = GlobalStylesNoFont;
var GlobalStyles = (0, _styledComponents.createGlobalStyle)(_templateObject4(), globalStyle, formStyles);
exports.GlobalStyles = GlobalStyles;